import http from '../http-common';

class ShareService {
  /**
   * Create a public token for an analysis. The token freezes the run being viewed
   * (M2 contract 5): pass `runId` to share a specific run, omit it to share the active run.
   * @param {'interview'|'manual_analysis'} sourceType
   * @param {number} sourceId
   * @param {string|null} runId
   */
  createShareToken(sourceType, sourceId, runId = null) {
    const body = { sourceType, sourceId };
    if (typeof runId === 'string' && runId.trim()) {
      body.run_id = runId.trim();
    }
    return http.post('share', body);
  }

  getSharedAnalysis(token) {
    return http.get(`share/${token}`);
  }
}

export default new ShareService();
